<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? 'Add Role' : 'Edit Role'}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? 'Add Role' : 'Edit Role'}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Role</h6>
            </div>
            <div>
              <ValidationObserver ref="currencyAddForm" id="currencyAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                  <label for="name" class="form-label">Name:</label>
                  <input id="name" class="form-control" name="name" v-model="formData.name" :class="checkValidation(classes)" placeholder="name" type="text">
                </ValidationProvider>
                <div class="d-flex justify-content-between align-items-center flex-wrap">
                  <ValidationProvider tag="div" class="w-50 d-flex justify-content-between align-items-center p-2 pr-4" v-for="(item, i) in formData.permissions" :key="i">
                    <label :for="i" class="form-label">{{item.name}}:</label>
                    <input :id="i" class="wd-25 ht-25" name="name" v-model="formData.permissions[i].checked"  type="checkbox">
                  </ValidationProvider>
                </div>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CurrencyAdd',
  data () {
    return {
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      // ckEditorConfig: {
      //   toolbar: [['Source', 'About', 'Styles', 'Format', 'Font', 'FontSize', 'Bold', 'Italic', 'Strikethrough', 'Heading', '|', 'Undo', 'Redo', '|', 'Link', 'BulletedList', 'NumberedList', 'BlockQuote', 'Image', 'Link', 'Unlink']],
      //   filebrowserImageUploadUrl: `${process.env.VUE_APP_WEB_API}image-upload`,
      //   fileTools_requestHeaders: {
      //     'X-Requested-With': 'XMLHttpRequest',
      //     Authorization: `Bearer ${localStorage.access_token}`
      //   }
      // },
      formData: {
        name: '',
        permissions: []
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      itemData: state => state.role.itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
      this.getPermissions().then((res) => {
        this.formData.permissions = res.map((item) => {
          item.checked = false
          return item
        })
      })
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
        this.formData.permissions = this.formData.permissions.map((item) => {
          if (this.itemData.role_permissions.includes(item.id)) {
            item.checked = true
          } else {
            item.checked = false
          }
          return item
        })
        delete this.formData.role_permissions
      })
    }
  },
  methods: {
    ...mapActions({
      create: 'role/create',
      update: 'role/update',
      getPermissions: 'role/getPermissions',
      getData: 'role/getData'
    }),
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          this.formData.permission = []
          this.formData.permissions.map((item) => {
            if (item.checked) {
              this.formData.permission.push(item.id)
            }
          })
          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/roles')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/roles')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
